module.exports = __webpack_public_path__ + "img/sphl.0a684d35.png";